import React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { Tag } from 'antd'
import { ExportOutlined, MenuUnfoldOutlined, HomeOutlined } from '@ant-design/icons'

const SCHEDULE_URL = '/schedule-app/?v=20260629'

export default function SchedulePage() {
  const navigate = useNavigate()
  const { collapsed, setCollapsed } = useOutletContext<{ collapsed: boolean; setCollapsed: (v: boolean) => void }>()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: collapsed ? '100vh' : 'calc(100vh - 48px)' }}>
      <div style={{
        background: '#fff', borderRadius: collapsed ? 0 : 10, padding: '10px 20px',
        marginBottom: collapsed ? 0 : 12,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)', flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {collapsed && (
            <MenuUnfoldOutlined
              onClick={() => setCollapsed(false)}
              style={{ fontSize: 18, color: '#536DFE', cursor: 'pointer', flexShrink: 0 }}
            />
          )}
          <span style={{ fontSize: 15, fontWeight: 600, color: '#333' }}>排班系统</span>
          <Tag color="blue" style={{ margin: 0 }}>负责人：顾颖</Tag>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
          <a href={SCHEDULE_URL} target="_blank" rel="noopener noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, color: '#536DFE', whiteSpace: 'nowrap' }}>
            <ExportOutlined /> 新窗口打开
          </a>
          <HomeOutlined onClick={() => navigate('/')} style={{ fontSize: 18, color: '#536DFE', cursor: 'pointer' }} title="返回首页" />
        </div>
      </div>
      <div style={{ borderRadius: collapsed ? 0 : 12, overflow: 'hidden', background: '#fff', boxShadow: collapsed ? 'none' : '0 2px 8px #E8EAFC' }}>
        <iframe src={SCHEDULE_URL} title="排班系统" style={{ width: '100%', height: '4000px', border: 'none', display: 'block' }} />
      </div>
    </div>
  )
}
